import {forwardRef} from "react";
import type { ComponentProps } from "react";
import * as React from "react";
import * as _ from "lodash";
import { SelectInput } from './select-input';

//todo make normal props
//type Props = ComponentProps<typeof SelectInput> & {
type Props = any & {
  formik: any,
  name: string,
  'data-test'?: string,
  required?: boolean,
  defaultValue?: any,
}

export const FormikSelectInput = forwardRef((props: Props, ref: any) => {
  const {formik, name, children, defaultValue, required, ...rest} = props;

  return <SelectInput ref={ref}
                     value={formik.values[name] || defaultValue}
                     error={formik.touched[name] && Boolean(formik.errors[name])}
                     helperText={formik.touched[name] && formik.errors[name]}
                     name={name}
                     label={rest.label || `${_.startCase(name)}${required ? ' *' : ''}`}
                     data-test={props['data-test'] || _.snakeCase(name)}
                     onChange={event => {
                       formik.setFieldValue(name, event.target.value as string);
                     }}
                     {...rest}
  >
    {children}
  </SelectInput>
})
